module.exports = __webpack_public_path__ + "23_pvis1.jpg?fc422664fb1a64adaa9177886e957d19";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/23_pvis1.jpg
// module id = 201
// module chunks = 0